export default __webpack_public_path__ + "static/media/one_to_many.e4daaeda.svg";